import { render, staticRenderFns } from "./MortgageePossession.vue?vue&type=template&id=6af4a3cb&scoped=true&"
import script from "./MortgageePossession.vue?vue&type=script&lang=js&"
export * from "./MortgageePossession.vue?vue&type=script&lang=js&"
import style0 from "./MortgageePossession.vue?vue&type=style&index=0&id=6af4a3cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af4a3cb",
  null
  
)

export default component.exports